var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.75,
    height: 19.75,
    viewBox: "0 0 19.75 19.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H19.75V19.75H0Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,7.16V5.185A.4.4,0,0,0,17.4,4.79H3.185a.4.4,0,0,0-.395.395V7.16Zm.79-1.975v11.06a2.765,2.765,0,0,1-2.765,2.765H4.765A2.765,2.765,0,0,1,2,16.245V5.185A1.185,1.185,0,0,1,3.185,4H17.4A1.185,1.185,0,0,1,18.59,5.185ZM2.79,7.95v8.295A1.975,1.975,0,0,0,4.765,18.22h11.06A1.975,1.975,0,0,0,17.8,16.245V7.95Z",
    transform: "translate(-0.42 -0.84)",
    fill: "#0c4767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.715,13.06a.395.395,0,0,1,0,.79H6.395a.395.395,0,1,1,0-.79ZM9.555,9.9a.395.395,0,1,1,0,.79H6.395a.395.395,0,1,1,0-.79ZM15.875,2a.4.4,0,0,1,.395.395v2.37a.395.395,0,1,1-.79,0V2.395A.4.4,0,0,1,15.875,2ZM7.185,2a.4.4,0,0,1,.395.395v2.37a.395.395,0,1,1-.79,0V2.395A.4.4,0,0,1,7.185,2Z",
    transform: "translate(-1.26 -0.42)",
    fill: "#fe9920"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanner);
export default __webpack_public_path__ + "static/media/Planner.592d7307ce5c90ae608e7a4b45935439.svg";
export { ForwardRef as ReactComponent };